import React, { Component } from "react";
import { observer } from "mobx-react";

import TelephoneString from "../TelephoneString";

class AuthFormPasswordResetSent extends Component {
  render() {
    const { className } = this.props;

    return (
      <div className={[className, "text-center", "_inputs"].join(" ")}>
        Bitte prüfen Sie Ihren Posteingang!
        <br />
        <br />
        Falls ein Konto mit dieser E-Mail Adresse existiert, haben wir nun eine Nachricht dorthin geschickt, um das
        Passwort wiederherzustellen.
        <br />
        <br />
        <strong>Keine E-Mail erhalten?</strong>
        <br />
        <br />
        1. Prüfen Sie in Ihrem E-Mail Postfach den Spam-Ordner oder bei Gmail die Ordner „Benachrichtigungen“ oder
        „Werbung“.<br />
        2. Rufen Sie uns unter der Händler-Hotline an: <TelephoneString /> oder schreiben Sie eine E-Mail an
        service@kitchenadvisor.de
      </div>
    );
  }
}

AuthFormPasswordResetSent = observer(AuthFormPasswordResetSent);

export default AuthFormPasswordResetSent;
